import React, { useMemo } from 'react';
import ProgrammesNavigationBar from './programmes_navigation_bar';
// import ProgrammeDeepDuplicateModal from './programme_deep_duplicate';
import ProgrammePlanBoard from './programme_plan_board';
import { useGetProgrammesQuery } from '../../app/smorgAppSyncGraphQLApi';
import ResourceLoadingModal from '../common/resource_loading_modal';

interface ProgrammeViewProps {
  programmeId: string;
  planId: string;
  // showDeepDuplicate: boolean;
}

const ProgrammeView = ({
  programmeId,
  planId,
}: /* showDeepDuplicate, */
ProgrammeViewProps) => {
  const { data: ownedProgrammes } = useGetProgrammesQuery(undefined);

  const programme = (ownedProgrammes || []).find((p) => p.id === programmeId);

  const currentPlan = useMemo(
    () => (programme?.plans || []).find((p) => p.id === planId),
    [programme?.plans, planId],
  );

  if (!programme) {
    return null;
  }

  if (!currentPlan) {
    return null;
  }

  return (
    <>
      <ProgrammesNavigationBar
        selectedProgrammeId={programmeId}
        selectedPlanId={currentPlan.id}
      />
      <ProgrammePlanBoard
        programmeId={programmeId}
        programmePlan={currentPlan}
        nutritionConstraints={programme.nutritionConstraints}
        showNutritionToUsers={programme.showNutritionToUsers}
      />
      {/* {showDeepDuplicate && (
        <ProgrammeDeepDuplicateModal programmeId={programmeId} />
      )} */}
    </>
  );
};

export default ProgrammeView;
